"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _uniqueBy = _interopRequireDefault(require("../../utils/array/uniqueBy"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _deepCopy = _interopRequireDefault(require("../../utils/object/deepCopy"));

var _isEmpty = _interopRequireDefault(require("../../utils/object/isEmpty"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _Filters = _interopRequireDefault(require("../../models/transform/filter/Filters"));

var _Transform = _interopRequireDefault(require("../../models/transform/Transform"));

var _creative = require("../../constants/creative");

var getFilterTransform = function getFilterTransform(leftFiltersTransform, rightFiltersTransform) {
  var easingTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var defaultFilters = (0, _deepCopy["default"])(_creative.DEFAULT_KEYFRAME_TRANSFORM.filters); // Set some default values if the whole filters object is missing

  if ((0, _isNil["default"])(leftFiltersTransform)) leftFiltersTransform = defaultFilters;
  if ((0, _isNil["default"])(rightFiltersTransform)) rightFiltersTransform = defaultFilters; // Merge the list of filters together to get the final lists of transforms. Use defaults where values are absent.

  var mergedFiltersList = (0, _uniqueBy["default"])([].concat((0, _toConsumableArray2["default"])(leftFiltersTransform.filters), (0, _toConsumableArray2["default"])(rightFiltersTransform.filters))); // Go through each filter list and set defaults on left or right if there are none

  mergedFiltersList.forEach(function (filterName) {
    [leftFiltersTransform, rightFiltersTransform].forEach(function (filterTransform) {
      if (!filterTransform.filters.includes(filterName)) {
        filterTransform.filters.push(filterName);
      }

      if ((0, _isEmpty["default"])(filterTransform.filtersByName[filterName])) {
        filterTransform.filtersByName[filterName] = defaultFilters.filtersByName[filterName];
      }
    });
  });
  var _leftFiltersTransform = leftFiltersTransform,
      leftOrderOfFilters = _leftFiltersTransform.filters,
      leftFiltersByName = _leftFiltersTransform.filtersByName;
  var _rightFiltersTransfor = rightFiltersTransform,
      rightOrderOfFilters = _rightFiltersTransfor.filters,
      rightFiltersByName = _rightFiltersTransfor.filtersByName; // use Filters model

  var leftFilters = new _Filters["default"](leftFiltersByName, leftOrderOfFilters);
  var rightFilters = new _Filters["default"](rightFiltersByName, rightOrderOfFilters);
  var updatedFilters = new _Filters["default"]();
  leftFilters.filters.forEach(function (filterName) {
    // check the following:
    // 1. filter is valid
    // 2. left filters contain that filter value
    if (!_creative.VALID_FILTERS.has(filterName) || (0, _isNil["default"])(leftFiltersByName[filterName])) return;
    var leftFilterValue = leftFilters.getValueByFilterName(filterName);
    if (!(0, _isNumber["default"])(leftFilterValue)) return;
    var rightFilterValue = rightFilters.getValueByFilterName(filterName);
    updatedFilters.addFilterByName(filterName, _Transform["default"].getEasingValue(leftFilterValue, rightFilterValue, easingTime));
  });
  return updatedFilters.toJSON();
};

var _default = getFilterTransform;
exports["default"] = _default;